export const NIGERIAN_STATES = [
  'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno',
  'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT', 'Gombe',
  'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara',
  'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau',
  'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara',
] as const;

export type NigerianState = (typeof NIGERIAN_STATES)[number];

// NOTE: Keep lists small-but-real (major cities/LGAs). This is for validation + preventing invalid combinations.
export const NIGERIAN_STATE_TO_CITIES: Record<NigerianState, string[]> = {
  Abia: ['Umuahia', 'Aba', 'Ohafia'],
  Adamawa: ['Yola', 'Mubi', 'Jimeta'],
  'Akwa Ibom': ['Uyo', 'Eket', 'Ikot Ekpene'],
  Anambra: ['Awka', 'Onitsha', 'Nnewi'],
  Bauchi: ['Bauchi', 'Azare', 'Misau'],
  Bayelsa: ['Yenagoa', 'Ogbia', 'Sagbama'],
  Benue: ['Makurdi', 'Gboko', 'Otukpo'],
  Borno: ['Maiduguri', 'Bama', 'Konduga'],
  'Cross River': ['Calabar', 'Ikom', 'Ogoja'],
  Delta: ['Asaba', 'Warri', 'Sapele'],
  Ebonyi: ['Abakaliki', 'Afikpo', 'Onueke'],
  Edo: ['Benin City', 'Auchi', 'Ekpoma'],
  Ekiti: ['Ado Ekiti', 'Ikere', 'Ise'],
  Enugu: ['Enugu', 'Nsukka', 'Awgu'],
  FCT: ['Abuja', 'Gwagwalada', 'Kuje'],
  Gombe: ['Gombe', 'Kaltungo', 'Billiri'],
  Imo: ['Owerri', 'Okigwe', 'Orlu'],
  Jigawa: ['Dutse', 'Hadejia', 'Gumel'],
  Kaduna: ['Kaduna', 'Zaria', 'Kafanchan'],
  Kano: ['Kano', 'Wudil', 'Bichi'],
  Katsina: ['Katsina', 'Daura', 'Funtua'],
  Kebbi: ['Birnin Kebbi', 'Argungu', 'Yauri'],
  Kogi: ['Lokoja', 'Okene', 'Idah'],
  Kwara: ['Ilorin', 'Offa', 'Omu-Aran'],
  Lagos: ['Ikeja', 'Lagos Island', 'Victoria Island', 'Lekki', 'Ikorodu', 'Epe'],
  Nasarawa: ['Lafia', 'Keffi', 'Akwanga'],
  Niger: ['Minna', 'Bida', 'Suleja'],
  Ogun: ['Abeokuta', 'Ijebu Ode', 'Sagamu', 'Ota'],
  Ondo: ['Akure', 'Ondo', 'Owo'],
  Osun: ['Osogbo', 'Ile-Ife', 'Ilesa'],
  Oyo: ['Ibadan', 'Ogbomoso', 'Oyo'],
  Plateau: ['Jos', 'Bukuru', 'Pankshin'],
  Rivers: ['Port Harcourt', 'Obio-Akpor', 'Bonny'],
  Sokoto: ['Sokoto', 'Wamakko', 'Tambuwal'],
  Taraba: ['Jalingo', 'Wukari', 'Serti'],
  Yobe: ['Damaturu', 'Potiskum', 'Gashua'],
  Zamfara: ['Gusau', 'Kaura Namoda', 'Talata Mafara'],
};

export function getCitiesForState(state: string): string[] {
  if (!state) return [];
  const normalized = state.trim();
  const match = (NIGERIAN_STATES as readonly string[]).find((s) => s === normalized);
  if (!match) return [];
  return NIGERIAN_STATE_TO_CITIES[match as NigerianState] ?? [];
}

export function isValidStateCity(state: string, city: string): boolean {
  if (!state || !city) return false;
  const cities = getCitiesForState(state);
  return cities.some((c) => c.toLowerCase() === city.trim().toLowerCase());
}
